import { Router, ActivatedRoute } from '@angular/router';
import { NotesService } from './../../../shared/services/notes.service';
import { Note } from './../../../shared/models/note';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notes-default',
  templateUrl: './notes-default.component.html',
  styleUrls: ['./notes-default.component.scss']
})
export class NotesDefaultComponent implements OnInit {
  public notes: Note[];
  public statusList: { idNoteStatus: number, name:string }[];
  constructor(
    private notesService: NotesService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getStatusNotes();
    this.getNotes();
  }

  getState(id) {
    return this.statusList.find(s => s.idNoteStatus == id);
  }
  getNotes() {
    this.notesService.getNotes().subscribe(
      (res: any) => {
        console.log(res);
        if(res.data) {
          this.notes = res.data;
        }
      },
      error => {
        console.log(error);
    });
  }
  async getStatusNotes() {
    this.statusList = await this.notesService.getNotesStatus();
    console.log(this.statusList);
  }
  onSelectStatus(e,row) {
    let _note = row.data;
    let _status = e.itemData.idNoteStatus;
    _note.status = _status;
    console.log(_note);
  }
  goToDetail(e) {
    console.log(e);
    //this.router.navigate(['detail',idNote], { relativeTo: this.route })
  }
}
